import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ScaleIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createStaffPayScale } from '../../api/staff-pay-scales/create-staff-pay-scale'
import UserNavBar from '../../components/elements/nav-bar'
import StaffPayScaleForm from '../../components/pages/staff/staff-pay-scale-form/staff-pay-scale-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

export function StaffPayScaleCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createStaffPayScale,
    onError: showAxiosError,
    onSuccess: () => toast.success('Barème de rémunération créé avec succès')
  })

  return (
    <div>
      <UserNavBar title="Créer des barèmes de rémunération" icon={ScaleIcon} />
      <div className="h-4" />
      <Box>
        <Typography variant="sub-heading" color={tailwindColors.primary.DEFAULT}>
          Barèmes de rémunération
        </Typography>
        <div className="h-4" />
        <StaffPayScaleForm
          defaultValues={{
            diplomas: [],
            qualifications: [],
            formulasId: [],
            countriesId: [],
            periodsId: []
          }}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.STAFF_PAY_SCALE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}
